export default __webpack_public_path__ + "static/media/WindowsTaskScheduler-Properties08.da235dd7.png";